import React, { useState, useEffect } from "react";
import createChart from "./helpers/createChart";
import { isEmpty, map } from "lodash";

const Graph = ({ groupedData }) => {
  const elementId = "revenue-graph";
  const heightGraph = 450;
  const [readyToRender, setReadyToRender] = useState(false);
  const [mode, setMode] = useState("revenues");
  const [error, setError] = useState(null);

  const options = {
    revenues: {
      key: 0,
      header: Drupal.t("Revenues"),
      name: Drupal.t("Revenues"),
      id: "revenues",
      field: "field_quarterly_sales"
    },
    ebitda: {
      key: 1,
      header: Drupal.t("EBITDA"),
      name: Drupal.t("EBITDA"),
      id: "ebitda",
      field: "field_quarterly_ebitda"
    },
    capex: {
      key: 2,
      header: Drupal.t("CAPEX"),
      name: Drupal.t("CAPEX"),
      id: "capex",
      field: "field_quarterly_capex"
    }
  };

  useEffect(() => {
    if (!isEmpty(groupedData)) {
      setReadyToRender(true);
    }
  }, [groupedData, mode]);

  useEffect(() => {
    if(readyToRender) {
      createChart(groupedData, elementId, options[mode]);
    }
  })

  if (readyToRender) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-between ml-2rem mr-2rem">
          <div>
            <b>{options[mode].header}</b>
          </div>

          <div>
            {map(options, (option, key) => (
                <div key={key} className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    onClick={() => setMode(option.id)}
                    type="radio"
                    name="financialResultsData"
                    id={option.id}
                    defaultChecked={mode === option.id}
                  />
                  <label className="form-check-label" htmlFor={option.id}>
                    {Drupal.t(option.name)}
                  </label>
                </div>
              )
            )}
          </div>
        </div>

        <div
          id={elementId}
          style={{ height: `${heightGraph}px` }}
        />
        <p className="font-size-dot80rem ml-96p">{Drupal.t("You can hide selected year's data on the chart by clicking its designation on the legend.")}</p>
      </>
    );
  }
  return (
    <div
      className="d-flex justify-content-center pb-4 pt-4"
      style={{ height: `${heightGraph}px` }}
    >
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Graph;
